export default "__VITE_ASSET__BZq0WXvZ__"